<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content m-b-sm border-bottom">
            <div class="row form-horizontal">
              <div class="form-group margin-0">
                <label class="col-sm-2 control-label"> Event Name </label>
                <div class="col-sm-4">
                  <div>
                    <el-input v-model="searchName" name="search"></el-input>
                  </div>
                </div>
                <div class="col-sm-2">

                </div>
              </div>
              <div v-if="userRole != 2" class="form-group margin-0">
                <label class="col-sm-2 control-label"> Event District </label>
                <div class="col-sm-4">
                  <div>
                    <el-select v-model="searchDistrictName" placeholder="Search District" clearable>
                      <el-option v-for="item in districtGetlist" :key="item.districtCode" :label="item.districtNameEn"
                        :value="item.districtCode">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class>
                    <el-button type="primary" @click="search">{{
                      $t("message.Search")
                    }}</el-button>
                  </div>
                </div>
              </div>
              <div class="form-group margin-0 notice" style="padding-left: 20px">
                <p>Notice:</p>
                <p>
                  1. For the security concern, please enter captcha when get NEW
                  event from CES;
                </p>
                <p>
                  2. Please note that the district user can ONLY get the
                  restricted district event from CES.
                </p>
              </div>
              <div class="row table-responsive" style="padding-bottom: 60px">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="handleArchiveEvent">Archive</el-button>
                    <el-button type="primary" @click="getCaptchaImageEvent">Manual Call event from CES</el-button>
                  </div>
                </div>
                <div class="col-xs-12">
                  {{ total }}{{ $t("message.datagridresult") }}
                </div>
                <el-table :data="rows" border style="width: 100%" ref="multipleTable"
                  @selection-change="handleSelectionChangeRows1" :fit="true" row-key="eventCode" class="rowss"
                  :cell-class-name="cell" :row-class-name='sortableFilter'>
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column label="Event Name" :show-overflow-tooltip="true" min-width="200">
                    <template slot-scope="scope">
                      <div>
                        <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.expired">
                          Expired
                        </el-tag>
                        {{ scope.row.title }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="categoryIds" :show-overflow-tooltip="true" label="Event Category"
                    min-width="130"></el-table-column>
                  <el-table-column prop="districtName" :show-overflow-tooltip="true" label="Event Direct"
                    min-width="130"></el-table-column>
                  <el-table-column prop="updatedAt" label="Last Update Time" width="170">
                  </el-table-column>
                  <el-table-column prop="statusName" label="Status" min-width="150"></el-table-column>
                  <el-table-column width="250">
                    <template slot-scope="scope">
                      <StatusBtn :ref="'statusBtnRef' + scope.row.eventCode" :id="scope.row.eventCode"
                        :status="scope.row.status" :init="init" :type="'EVENT'" :approval="'EVENT_LIST_APPROVAL'"
                        @approve-click="handleApproveClick(scope.row, $event)"></StatusBtn>
                    </template>
                  </el-table-column>
                  <el-table-column width="140">
                    <template slot-scope="scope">
                      <el-button v-if="![2, 6].includes(scope.row.status)"
                        @click="getCaptchaImageEvent(true, scope.row.eventCode)" class="el-button-blue" size="mini"
                        type="primary" slot="reference" style="width:110px">Refresh
                      </el-button>
                    </template>
                  </el-table-column>
                  <el-table-column label="Action" width="180" fixed="right">
                    <template slot-scope="scope">
                      <el-row>
                        <el-col :span="6" style="float: right" v-if="canDrag">
                          <div class="text-center dragTip">=</div>
                        </el-col>
                        <el-col :span="9" style="float: right">
                          <el-button :disabled="![5, 6].includes(scope.row.status)" size="mini"
                            @click="handlePreposition(scope.row)" icon="el-icon-caret-top"></el-button>
                        </el-col>
                        <el-col :span="9" style="float: right">
                          <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>
                <el-col :span="24" class="el-table_footertoolbar">
                  <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100, 200]" :page-size="pagesize"
                    :total="total" style="float: right">
                  </el-pagination>
                </el-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-content m-b-sm border-bottom" style="margin-top: 20px">
      <div class="row form-horizontal">
        <el-table :data="rows1" border style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange"
          :fit="true" row-key="eventCode" :cell-class-name="cell">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="Event Name" :show-overflow-tooltip="true" min-width="200">
            <template slot-scope="scope">
              <div>
                <el-tag type="warning" effect="dark" size="mini" v-if="scope.row.expired">
                  Expired
                </el-tag>
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="categoryIds" :show-overflow-tooltip="true" label="Event Category"
            min-width="130"></el-table-column>
          <el-table-column prop="districtName" :show-overflow-tooltip="true" label="Event Direct"
            min-width="130"></el-table-column>
          <el-table-column prop="updatedAt" label="Last Update Time" width="170">
          </el-table-column>
          <el-table-column prop="statusName" label="Status" min-width="150"></el-table-column>
          <el-table-column width="250">
            <template slot-scope="scope">
              <StatusBtn :id="scope.row.eventCode" :status="scope.row.status" :init="init" :type="'EVENT'"
                :approval="'EVENT_LIST_APPROVAL'"></StatusBtn>
            </template>
          </el-table-column>
          <el-table-column label="Action" width="120" fixed="right">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="12" style="float: right" v-if="canDrag">
                  <div class="text-center dragTip">=</div>
                </el-col>
                <el-col :span="12" style="float: right">
                  <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
        <el-col :span="24" class="el-table_footertoolbar">
          <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize1"
            :total="total1" style="float: right">
          </el-pagination>
        </el-col>
      </div>
    </div>
    <el-dialog title="" :visible.sync="selectCaptchaDlg" width="70%" :append-to-body="true" center>
      <div class="form-group">
        <img :src="captcha.captchaImage" />
      </div>
      <div class="form-group">
        <el-input v-model="answer"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectCaptchaDlg = false">Cancel</el-button>
          <el-button type="primary" @click="refreshEvent()">Confirm</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="selectCaptchaDlgRefresh" width="70%" :append-to-body="true" center>
      <div class="form-group">
        <img :src="captcha.captchaImage" />
      </div>
      <div class="form-group">
        <el-input v-model="answer"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="form-group">
          <el-button @click="selectCaptchaDlgRefresh = false">Cancel</el-button>
          <el-button type="primary" @click="refreshEvent('single')">Confirm</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="customApproveDialogVisible" width="70%" :append-to-body="true" center>
      <div>
        <p>IDEAS points and/or Application Date has been updated. Please enter CAPTCHA to confirm?</p>
        <div class="form-group" v-if="approveCaptcha.captchaImage">
          <img :src="approveCaptcha.captchaImage" />
        </div>
        <div class="form-group">
          <el-input v-model="approveAnswer" placeholder="Please input captcha"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customApproveDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmCustomApprove">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import config from "../config";
import Sortable from "sortablejs";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      searchDistrictName: '',
      eventListSelected: [],
      page: 1, //当前页数
      pagesize: 100, //一页显示几条
      page1: 1, //当前页数
      pagesize1: 100, //一页显示几条
      filter: "",
      name: "",
      searchStatus: null,
      total: 0,
      total1: 0,
      rows: [],
      rows1: [],
      multipleSelection: [],
      sortType: "ASC",
      sortField: "sortOrder",
      status: "",
      statusObj: [],
      typeObj: [],
      type: "",
      status: "",
      startDate: "",
      endDate: "",
      period: null,
      canDrag: false,
      searchName: "",
      captcha: {},
      answer: "",
      selectCaptchaDlg: false,
      selectCaptchaDlgRefresh: false,
      refreshEventId: null,
      districtGetlist: [],
      // approve的弹窗
      customApproveDialogVisible: false,
      // 存储approve captcha相关信息
      approveCaptcha: {},
      // 存储approve captcha答案
      approveAnswer: "",
      // 存储当前审批事件信息
      approveEventInfo: null,
    };
  },
  components: {
    StatusBtn,
  },
  created: function () {
    this.init1();
    if (this.userRole != 2) this.getDistrictGetlist()
    if (this.checkPermission("EVENT_LIST_ORDER")) {
      this.canDrag = true;
    }
  },
  computed: {
    userInfo() {
      return this.getAuthObj();
    },
    baseURL() {
      return config.domain + "/";
    },
    userRole() {
      const res = JSON.parse(sessionStorage.getItem("userInfo"));
      return res.roleType;
    },
  },
  methods: {
    handleSizeChange1(val) {
      this.pagesize1 = val;
      this.init1();
    },
    handleCurrentChange1(val) {
      this.page1 = val;
      this.init1();
    },
    async getDistrictGetlist() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.districtGetlist;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$set(this, "districtGetlist", data.data.result);
    },
    async init1() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page1;
      objdata.pageSize = this.pagesize1;
      objdata.title = this.searchName;
      objdata.districtCode = this.searchDistrictName

      objdata.sortName = this.sortField;
      objdata.sortType = this.sortType;
      objdata.expired = "1";

      objdata.apiUrl = this.apiConfig.eventList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      // this.rows = data.data.result.events;
      this.$set(this, "rows1", data.data.result.events);
      this.setObj();
      this.total1 = data.data.result.total;
    },
    async init() {
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.title = this.searchName;
      objdata.archived = "0";
      objdata.sortName = "status";
      objdata.districtCode = this.searchDistrictName
      objdata.sortType = this.sortType;
      objdata.expired = "2";

      objdata.apiUrl = this.apiConfig.eventList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      // this.rows = data.data.result.events;
      this.$set(this, "rows", data.data.result.events);
      this.setObj();
      this.total = data.data.result.total;
    },
    async handlePreposition(eventItem) {
      var objdata = this.getAuthObj();
      objdata.archived = "0";
      objdata.title = this.searchName;
      objdata.expired = "2";
      objdata.eventCode = eventItem.eventCode

      objdata.apiUrl = this.apiConfig.eventPreposition;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      await this.init();
    },
    async getCaptchaImageEvent(isRefresh, id) {
      isRefresh && (this.refreshId = id)
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.eventGetCaptchaImage;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      data.data.result.captchaImage =
        "data:image/jpg;base64," + data.data.result.captchaImage;
      this.captcha = data.data.result;
      if (id) {
        this.selectCaptchaDlgRefresh = true;
      } else {
        this.selectCaptchaDlg = true
      }
      //isRefresh?this.selectCaptchaDlgRefresh = true:this.selectCaptchaDlg = true;
    },
    async refreshEvent(type) {
      var objdata = this.getAuthObj();
      objdata.eventCode = this.refreshId;
      objdata.answer = this.answer;
      objdata.captcha = this.captcha.captcha;
      objdata.captchaId = this.captcha.captchaId;

      if (type === 'single') {
        objdata.apiUrl = `/event/singleSync`;
      } else {
        objdata.apiUrl = `/event/sync`;
      }

      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) {
        this.getCaptchaImageEvent();
        return;
      }
      this.init()
      this.selectCaptchaDlgRefresh = false;
      this.selectCaptchaDlg = false
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.page = 1;
      this.page1 = 1;
      this.init();
      this.init1();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function ({ row }) {
      if (!this.canDrag) {
        return "disabled pointer";
      }
      // if (row.status == 1) {
      return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/eventDetail",
        query: {
          id: row.eventCode,
        },
      });
    },
    gotoDetail() {
      this.$router.push({ path: "/main/eventDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(",");

      objdata.apiUrl = this.apiConfig.eventDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
        this.init1();
      }
    },
    setObj: function () {
      this.statusObj = [
        {
          value: "1",
          label: this.$i18n.t("message.Active"),
        },
        {
          value: "0",
          label: this.$i18n.t("message.Inactive"),
        },
      ];
      this.typeObj = [
        {
          value: 0,
          label: "Broadcast message",
        },
        {
          value: 1,
          label: "Promotion",
        },
      ];
      let list = null;
      for (list of this.rows) {
        if (list.status === 0) {
          list.statusName = "Draft";
        } else if (list.status == 1) {
          list.statusName = "Pending approval";
        } else if (list.status == 2) {
          list.statusName = "Pending Publish";
        } else if (list.status == 3) {
          list.statusName = "Rejected";
        } else if (list.status == 4) {
          list.statusName = "Suspended";
        } else if (list.status == 5) {
          list.statusName = "Pending Suspend";
        } else if (list.status == 6) {
          list.statusName = "Published";
        }
      }
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.rows.length; i++) {
        if ([5, 6].includes(this.rows[i].status)) {
          sortOrder.push({
            id: this.rows[i].eventCode,
            displayOrder: this.rows[i].sortOrder,
          });
        }

      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.eventOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.init();
    },
    handleSelectionChangeRows1(val) {
      this.eventListSelected = val.map((i) => {
        return i.eventCode;
      });
    },
    async handleArchiveEvent() {
      const param = {
        lstEventCode: this.eventListSelected,
        status: 1,
        ...this.userInfo,
      };
      const {
        data: { status_code, status_message },
      } = await axios.post(this.baseURL + "event/updateArchivedStatus", param);
      if (status_code == "0") {
        this.init();
      } else {
        this.$store.getters.warning.warningMsg = status_message;
        this.$store.getters.warning.warningFalg = true;
      }
    },
    sortableFilter(item) {
      return [2, 5, 6].includes(item.row.status) ? '' : 'disabled'
    },

    // 刷新验证码
    async refreshApproveCaptcha() {
      let objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.eventGetCaptchaImage;
      let captchaData = await this.$store.dispatch("apiEvent", objdata);
      if (!captchaData) return false;
      captchaData.data.result.captchaImage =
        "data:image/jpg;base64," + captchaData.data.result.captchaImage;
      this.approveCaptcha = captchaData.data.result;
      this.approveAnswer = "";
      return true;
    },
    async handleApproveClick(row, { id, status, type }) {
      // console.log("status的btn被点了", id, status, type, row);
      if (row.updateCesCoreStatus === 1) {
        const ok = await this.refreshApproveCaptcha();
        if (!ok) return;
        console.log(row)
        this.approveCaptcha.eventCode = row.eventCode;
        // 弹出我的 dialog
        this.customApproveDialogVisible = true;
        // 存储statusBtn传来的信息
        this.approveEventInfo = { id, status, type };
      } else {
        // 走子组件逻辑
        this.$refs['statusBtnRef' + id].updateStatusEvent(
          id,
          2,
          type
        );
      }
    },
    // dialog确认后再调用 updateStatusEvent
    async confirmCustomApprove() {
      let objdata = this.getAuthObj();
      objdata.answer = this.approveAnswer
      objdata.captcha = this.approveCaptcha.captcha
      objdata.captchaId = this.approveCaptcha.captchaId
      objdata.eventId = this.approveCaptcha.eventCode;
      objdata.apiUrl = '/eventScoreEnrolDate/update';
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (!data) {
        await this.refreshApproveCaptcha();
        return;
      }
      if (!data.data.result.updateStatus) {
        await this.refreshApproveCaptcha();
        return;
      }
      // 用子组件的updateStatusEvent
      const statusBtnData = await this.$refs['statusBtnRef' + this.approveEventInfo.id].updateStatusEvent(
        this.approveEventInfo.id,
        2,
        this.approveEventInfo.type,
      );
      if (!statusBtnData) {
        await this.refreshApproveCaptcha();
        return;
      }
      this.customApproveDialogVisible = false;
    }
  },
  mounted() {
    this.init();
    const table = document.querySelector(
      ".rowss .el-table__body-wrapper tbody"
    );
    var self = this;
    Sortable.create(table, {
      onEnd({ newIndex, oldIndex }) {
        self.updateNewsOrder(newIndex, oldIndex);
      },
      filter: '.disabled',
      onMove: (event) => {
        return !event.related.classList.contains("disabled");
      },
    });
  },
};
</script>
